import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Dark mode removed — force the light theme for everyone and clear any
// previously-saved "dark" preference so no login stays dark.
try {
  document.documentElement.setAttribute('data-theme', 'light');
  localStorage.removeItem('amshrms-theme');
} catch (_) { /* ignore */ }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
